/**
 * WordPress dependencies
 */
import { Modal } from '@wordpress/components';
import { withInstanceId } from '@wordpress/compose';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import ResLabelControl from '../res-label-control';
import ICONS from './icons';

// iconpicker control
const IconPickerControl = ({ label, value, onChange, help = '', instanceId }) => {
    const id = `icon-picker-control-${instanceId}`;

    const [iconsModal, setIconsModal] = useState(false);
    const [searchText, setSearchText] = useState('');

    return (
        <div className="faqmate-control-container">
            <div className="faqmate-mb-8">
                <ResLabelControl requiredProps={id} label={label} noResBtns={true} />
            </div>
            <div className="faqmate-icons-wrapper">
                <button
                    className="faqmate-icon-btn faqmate-preview"
                    onClick={() => {
                        setIconsModal(true);
                    }}
                >
                    {ICONS[value]}
                </button>
            </div>
            {iconsModal && (
                <Modal
                    title={__('Faqmate Blocks Icons', 'faqmate-blocks')}
                    onRequestClose={() => setIconsModal(false)}
                    className="faqmate-icons-modal"
                >
                    <div className="faqmate-icons-search">
                        <input
                            type="text"
                            placeholder={__('Search Icons', 'faqmate-blocks')}
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                        />
                    </div>
                    <div className="faqmate-icons-list">
                        {searchText !== ''
                            ? Object.keys(ICONS)
                                  .filter(icon => icon.includes(searchText))
                                  .map((icon, index) => {
                                      return (
                                          <button
                                              key={index}
                                              onClick={() => {
                                                  onChange(icon);
                                                  setIconsModal(false);
                                              }}
                                              className={classNames('faqmate-icon-btn', {
                                                  active: value === icon
                                              })}
                                          >
                                              {ICONS[icon]}
                                          </button>
                                      );
                                  })
                            : Object.keys(ICONS).map((icon, index) => {
                                  return (
                                      <button
                                          key={index}
                                          onClick={() => {
                                              onChange(icon);
                                              setIconsModal(false);
                                          }}
                                          className={classNames('faqmate-icon-btn', {
                                              active: value === icon
                                          })}
                                      >
                                          {ICONS[icon]}
                                      </button>
                                  );
                              })}
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default withInstanceId(IconPickerControl);
